import { DIIA_DEEPLINK_REQUEST, DIIA_DEEPLINK_SUCCESS, DIIA_DEEPLINK_FAILURE } from '../actions/diia';
import { DIIA_AUTH_REQUEST, DIIA_AUTH_SUCCESS, DIIA_AUTH_FAILURE } from '../actions/diia';
import { DIIA_SIGN_REQUEST, DIIA_SIGN_SUCCESS, DIIA_SIGN_FAILURE } from '../actions/diia';
import { DIIA_RESET } from '../actions/diia';

const initialState = {
    auth: {
        state: 'idle',
    },
    sign: {
        state: 'idle',
    },
    state: 'idle',
};

export default function auth(state = initialState, action) {
    switch (action.type) {
        case DIIA_DEEPLINK_REQUEST:
            return {
                ...state,
                state: 'loading',
            };
        case DIIA_DEEPLINK_SUCCESS:
            return {
                ...state,
                ...action.payload,
                state: 'success',
            };
        case DIIA_DEEPLINK_FAILURE:
            return {
                ...state,
                state: 'failure',
            };
        case DIIA_AUTH_REQUEST:
            return {
                ...state,
                auth: {
                    ...state.auth,
                    state: 'loading',
                },
            };
        case DIIA_AUTH_SUCCESS:
            return {
                ...state,
                auth: {
                    ...state.auth,
                    ...action.payload,
                    state: 'success',
                },
            };
        case DIIA_AUTH_FAILURE:
            return {
                ...state,
                auth: {
                    ...state.auth,
                    state: 'failure',
                },
            };
        case DIIA_SIGN_REQUEST:
            return {
                ...state,
                sign: {
                    ...state.sign,
                    state: 'loading',
                },
            };
        case DIIA_SIGN_SUCCESS:
            return {
                ...state,
                sign: {
                    ...state.sign,
                    ...action.payload,
                    state: 'success',
                },
            };
        case DIIA_SIGN_FAILURE:
            return {
                ...state,
                sign: {
                    ...state.sign,
                    state: 'failure',
                },
            };
        case DIIA_RESET:
            return {
                ...initialState
            };
        default:
            return state;
    }
}
